<div class="contact-us-form">
  <h2>Contact Us</h2>
  <form (ngSubmit)="onSubmit()" [formGroup]="formGroup">

    <!-- Name -->
    <div class="form-group">
      <label for="name">Name</label>
      <input
        type="text"
        id="name"
        name="name"
        formControlName="name"
        required
        class="form-control"
        placeholder="Your Full Name"
        maxlength="100"
        />
      </div>

      <!-- Email -->
      <div class="form-group">
        <label for="email">Email</label>
        <input
          type="email"
          id="email"
          name="email"
          formControlName="email"
          required
          class="form-control"
          placeholder="Your Email Address"
          />
        </div>

        <!-- Subject -->
        <div class="form-group">
          <label for="subject">Subject</label>
          <input
            type="text"
            id="subject"
            name="subject"
            formControlName="subject"
            required
            maxlength="100"
            class="form-control"
            placeholder="Subject"
            />
          </div>

          <!-- Message -->
          <div class="form-group">
            <label for="message">Message</label>
            <textarea
              id="message"
              name="message"
              formControlName="message"
              required
              class="form-control"
              placeholder="Your Message"
              rows="5"
              maxlength="2000"
            ></textarea>
          </div>

          <!-- Submit Button -->
          <button type="submit" class="btn btn-primary" [disabled]="!formGroup.valid">
            Send Message
          </button>
        </form>

        <!-- Success Message -->
        @if (successMessage) {
          <p class="success-message">
            {{ successMessage }}
          </p>
        }
      </div>
